export const constants = {
  PASSWORD_VALIDATION_REGEX: /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]))([A-Za-z\d@#$%^&*\-_+=[\]{}|\\:',?\/`~\"();!]|\.(?!@)){8,16}$/,
  TABLET_WIDTH: 767,
  EMAIL_VALIDATION_REGEX: "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)",
  FIRSTNAME_VALIDATION_REGEX: /^[a-zA-Z][a-zA-Z\s'\-]{0,13}$/,
  LASTNAME_VALIDATON_REGEX: /^[a-zA-Z][a-zA-Z\s'\-]{0,28}$/,
  DEFAULT_PRODUCTION_POLICY: 'https://www.toyota.com/',
  DEFAULT_QA_POLICY: 'https://staging2.tcom.aws.toyota.com',
  DEFAULT_TEST_POLICY: 'https://test1.tcom.aws.toyota.com',
  DEFAULT_DEV_POLICY: 'https://dev1.tcom.aws.toyota.com',
  INVALID_ACTIVATION_CODE: 'M06001',
  ACTIVATION_CODE_EXPIRED: 'M06002',
  USER_ALREADY_ACTIVATED: 'M06007',
  INACTIVATED_EMAIL_ID: 'M07042',
  REGISTER_NAME_TITLE: 'Create your account',
  REGISTER_PASSWORD_TITLE: 'Create a password',
  REGISTER_COMPLETE_TITLE: 'Complete your registration',
  REGISTER_ERROR_TITLE: 'Error creating account!',
  ACTIVATE_LOADING_TITLE: 'Activating your new account…',
  ACTIVATE_SUCCESS_TITLE: 'Your account has been activated!',
  ACTIVATE_FAIL_TITLE: 'Sorry, we couldn’t activate your account.',
  RESET_SEND_EMAIL_TITLE: 'Let’s reset your password.',
  RESET_EMAIL_SENT_TITLE: 'Did you get our email?',
  RESET_SEND_EMAIL_SUBTITLE: 'To reset your password, please enter the email associated with your account.',
  EMAIL_VALIDATION_ERROR: 'Your email must be in the format name@domain.com. Your ‘name’ is limited to 64 characters and may include letters, numbers, underscores ( _ ), hyphens, periods, or a plus sign after the first letter. The ‘domain’ can include letters, numbers and hyphens only. Your overall email address must be 100 characters or less.',
  PASSWORD_VALIDATION_ERROR: 'Minimum of 8 characters and a maximum of 16. Must have at least three of the following: uppercase letter, lowercase letter, number (0-9) and/or special character/symbol. Password is case-sensitive.',
  CONFIRM_PASSWORD_VALIDATION_ERROR: 'Passwords do not match.',
  FIRSTNAME_VALIDATION_ERROR: 'Your first name must be between 1 and 14 characters. It can include spaces, apostrophes and hyphens.',
  LASTNAME_VALIDATION_ERROR: 'Your last name must be between 1 and 29 characters. It can include spaces, apostrophes and hyphens.',
  RESEND_NOT_FOUND_ERROR: 'We were not able to activate your account. Please check that your email address is correct and try again.',
  RESEND_ERROR: 'We were not able to activate your account. Please try again.',
  RESEND_ACTIVATED_ERROR: 'The email address you provided is linked to an existing account. Try signing in with that email, or provide a different email address.',
  RESEND_TITLE: 'Let’s get your account activated.',
  PASSWORD_TITLE: 'Create a new password.',
  PASSWORD_ERROR_TITLE: 'Sorry, we couldn’t reset your password.',
  PASSWORD_LOADING_TITLE : 'Setting your new password...',
  PASSWORD_SUCCESS_TITLE : 'Your password has been updated successfully!',
  PASSWORD_EXPIRED_TITLE : 'Your password reset link has expired.',
  PASSWORD_INVALID_TITLE : 'The reset link you entered is invalid.',
  PASSWORD_USED_TITLE : 'It appears this reset link has already been used.',
  PASSWORD_SERVICE_FAILURE_TITLE: 'We were not able to reset your password at this time.',
  PASSWORD_ERROR_SUBTITLE : 'Please try again.',
  PASSWORD_EXPIRED_SUBTITLE : 'Please reenter your email address to receive another link and try again.',
  PASSWORD_INVALID_SUBTITLE : 'Please try a different link, or reenter your email address and try again.',
  PASSWORD_USED_SUBTITLE : 'Please try logging in with your new password. Or, reenter your email address for a new link.',
  PASSWORD_SERVICE_FAILURE_SUBTITLE: 'Please try again later.',
  TAG_LINK: 'aa-link',
  TAG_PAGE: 'aa-pageload',
  TAG_RESEND_CONTENT: 'registration_resend_activation',
  CLIENT: 'SI-REG',
  CONTENT_TYPE: 'application/json',
  VERSION: '1.6',
  BRAND: 'T'
};

export const USER_ID_QUERY_PARAM = 'email';